import React from 'react';
import { Link } from 'react-router-dom';

const Support: React.FC = () => {
  return (
    <div className="iframe-page">
      <h1 className="page-title">Support</h1>
      <p className="page-subtitle" style={{ marginBottom: '1rem' }}>
        Have a question or need help? Fill out the form below and we&apos;ll get back to you.
      </p>
      <div className="iframe-wrapper">
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSfJfyQPxrraxI4x8vaWqJivWxvbfKk2Ad0pl7qBYYVZtDvUag/viewform?embedded=true"
          title="Bye For Now Support Form"
          width="640"
          height="541"
        >
          Loading…
        </iframe>
      </div>
      <Link to="/" className="page-back-link" style={{ marginTop: '1.5rem' }}>
        ← Back to home
      </Link>
    </div>
  );
};

export default Support;
